const devices = [{
  text: 'Responsive',
  value: 'responsive',
  width: '100%',
  height: '100%'
}, {
  text: 'iPhone SE',
  value: 'iphone-se',
  width: 375,
  height: 667
}, {
  text: 'iPhone XR',
  value: 'iphone-xr',
  width: 414,
  height: 896
}, {
  text: 'iPhone 12 Pro',
  value: 'iphone-12-pro',
  width: 390,
  height: 844
}, {
  text: 'Pixel 5',
  value: 'pixel-5',
  width: 393,
  height: 851
}, {
  text: 'Samsung Galaxy S8+',
  value: 'samsung-galaxy-s8-plus',
  width: 360,
  height: 740
}, {
  text: 'Samsung Galaxy S20 Ultra',
  value: 'samsung-galaxy-s20-ultra',
  width: 412,
  height: 915
}, {
  text: 'iPad Air',
  value: 'ipad-air',
  width: 820,
  height: 1180
}, {
  text: 'iPad Mini',
  value: 'ipad-mini',
  width: 768,
  height: 1024
}, {
  text: 'Surface Pro 7',
  value: 'surface-pro-7',
  width: 912,
  height: 1368
}, {
  text: 'Surface Duo',
  value: 'surface-duo',
  width: 540,
  height: 720
}, {
  text: 'Galaxy Fold',
  value: 'galaxy-fold',
  width: 280,
  height: 653
}, {
  text: 'Samsung Galaxy A51/71',
  value: 'samsung-galaxy-a51-71',
  width: 412,
  height: 914
}, {
  text: 'Nest Hub',
  value: 'nest-hub',
  width: 1024,
  height: 600
}, {
  text: 'Nest Hub Max',
  value: 'nest-hub-max',
  width: 1280,
  height: 800
}]

export default devices



// WEBPACK FOOTER //
// ./src/helpers/device-emulator-devices.js